/**
 * @title account-helper.js: Sub-module for Account pages
 * @description This module is used to handle various account tasks
 * @dependency
 */
define([], function() {
  
  let AccountHelper = {

    /**
     * Initialization of the module.
     */
    init: function() {
    console.log('Account Helper module intialized.');
    if (COSTCO.util.isRunningOnMobileApp() && !COSTCO.util.isBusinessDelivery()) {
	   if (document.readyState == 'complete') {
			$('#my-account-top-nav').on("click", function() {
				COSTCO.AccountHelper.showMobileMyAccountMenu();
			});
		} else {
			$(window).on('load', function() {
				$('#my-account-top-nav').on("click", function() {
					COSTCO.AccountHelper.showMobileMyAccountMenu();
				});
			})
		}
    } 
    },
    /**
     * Constants
     */
    notificationType: {
      SUCCESS: 'SUCCESS',
      WARNING: 'WARNING',
      ERROR: 'ERROR',
    },

    /**
     * Displays error, warning, or success notification
     * @param  {String} notificationType Notification type
     * @param  {Array} notifications     Notification messages
     * @return {void}
     */
    displayTopNotification: function(notificationType, notifications) {
      
    	this.clearNotification();

      let topNotificationClass = '';
      let topNotificationInnerHtml = '';

      switch (notificationType) {
        case this.notificationType.SUCCESS:
          topNotificationClass = 'success-notification';
          break;
        case this.notificationType.WARNING:
          topNotificationClass = 'warning';
          break;
        case this.notificationType.ERROR:
          topNotificationClass = 'critical-notification';
          break;
        default:
          break;
      }

      notifications.forEach(function(notification) {
        topNotificationInnerHtml += '<p automation-id="notificationMessage">' + notification + '</p>';
      });
      $('#notification-message').addClass(topNotificationClass);
      $('#notification-message').html(topNotificationInnerHtml);
    },
    /**
     * Clears top notification
     */
    clearNotification: function() {

      $('#notification-message').removeClass();
      $('#notification-message').html('');
    },
    /**
     * Makes dropdown menu options clickable and redirecting to URL stated in
     * option value attribute, when this HTML class attribute is used.
     * Used in Top Navigation dropdown menu.
     */
    activateDropdownMenuRedirect: function() {
      $('.dropdown-menu-redirect').unbind('change').change(function() {
        window.location.href = $(this).val();
      });
    },
    /**
     * Reinitializes value selected in  a dropdown manu when the back button is clicked
     */
    reinitDropDownMenu: function() {
  	  $('.dropdown-menu-redirect').each(function () {
  	    var select = $(this);
  	    var selectedValue = select.find('option[selected]').val();

  	    if (selectedValue) {
  	      select.val(selectedValue);
  	    } else {
  	      select.prop('selectedIndex', 0);
  	    }
  	  });
  	},
  	/**
	 * Function used to invoke the mobile app My Account navigation
	 */
	showMobileMyAccountMenu: function() {
		console.log('Initializing Mobile My Account Menu');
		try {
	        if (typeof Android != 'undefined') {
	        	Android.showMyAccount()
	        } 
	        else if (typeof webkit != 'undefined') {
	        	webkit.messageHandlers.showMyAccount.postMessage('myaccount');
	        }
	      }
	      catch (e) {
	        console.warn(e);
	      }
  },
  
  /**

     * Adds aria-current for ADA Compliance on "Left Navbar" link for account.
     * @return void
     */
    addAdaComplianceOnLeftNabarForAccount: function() {
      $('#leftnav li.active a').attr('aria-current', "page");
    },
  };

  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }

  window.COSTCO.AccountHelper = AccountHelper;

  return AccountHelper;
});



// WEBPACK FOOTER //
// ./js/account/account-helper.js